export const MODULE_KEY_SUCCESS = 'successPage';
